import * as login from './modules/login'
import * as home from './modules/home'
import * as index from './modules/index'
import * as website from './modules/website'
import * as publish from './modules/publishNew'
import * as imageConfig from './modules/imageConfig'
import * as system from './modules/system'

export default {
  login,
  home,
  index,
  website,
  publish,
  imageConfig,
  system
}
